import { useTrans } from "@/translations";

import { useMemo } from "react";

import { twMerge } from "tailwind-merge";

import { type KeyNumberColumn, SortDir } from "../types";

type Props = {
  col: KeyNumberColumn;
  activeKey: string;
  sortDir: SortDir;
  onSort: (key: string) => void;
};

export const ColumnHeader: React.FC<Props> = ({
  col,
  activeKey,
  sortDir,
  onSort,
}) => {
  const { t } = useTrans();

  const active = useMemo(() => activeKey === col.key, [activeKey, col]);

  return (
    <th
      onClick={() => onSort(col.key)}
      className={twMerge(
        "cursor-pointer pb-[8.25px] font-medium whitespace-nowrap select-none",
        col.align === "right" ? "text-right" : "text-left",
        active ? "text-black" : "text-grey6",
      )}
    >
      {t(col.label)}
      <span
        className={twMerge(
          "ml-[5px] text-[8px]",
          active ? "text-black" : "text-grey3",
        )}
      >
        {active ? (sortDir === SortDir.ASC ? "▲" : "▼") : "▼"}
      </span>
    </th>
  );
};
